module.exports = __webpack_public_path__ + "lush-and-dry-garden-new.jpg?4961d4a0908c4898a424bfb3e5694b9b";


//////////////////
// WEBPACK FOOTER
// ./src/images/lush-and-dry-garden-new.jpg
// module id = 149
// module chunks = 0